export const EVENT_KEY = "EVENT";

export const EVENT_TIMESTAMP_KEY = "timestamp";
export const EVENT_CUSTOMER_NAME_KEY = "customerId";
export const EVENT_WASTE_TYPE_NAME_KEY = "containerId";
export const EVENT_WASTE_ROOM_NAME_KEY = "wasteRoomId";
export const EVENT_WEIGHT_KEY = "weight";
